import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Trans } from '@lingui/macro'
import { useInputChange } from 'hooks/useInputChange'
import { InputText } from 'components/UI/InputText/InputText'
import { Button } from 'components/UI/Button/Button'
import { Loader } from 'components/UI/Loader/Loader'
import { IdTicketsState } from 'model/dashboardTickets/dTicketsReducer';
import { dTicketsAddItemSagaAC } from 'model/dashboardTickets/dTicketsActionCreators';
import { InputTextarea } from 'components/UI/InputTextarea/InputTextarea';

import { PencilAltIcon } from '@heroicons/react/outline';
import { TICKETSTATUS } from 'constants/ticketsStatus';

// Type
export type typePopupEdit = {
    variant?: string
    setOpenPopup: React.Dispatch<React.SetStateAction<boolean>>
}

// Component
export const PopupAdd: React.FC<typePopupEdit> = ({ variant, setOpenPopup }) => {

    const dispatch = useDispatch()

// System data
    const filters = useSelector((state: { dTickets: IdTicketsState }) => state.dTickets.filters)

// Form data
    const { value: descriptionValue, changeValueHandler: descriptionChangeValueHandler } = useInputChange('')
    const { value: titleValue, changeValueHandler: titleChangeValueHandler } = useInputChange('')

    const [ startValidation, setStartValidation ] = useState(false)

    const [ loader, setLoader ] = useState(false)

    // Validation
    const [ validationObj, setValidationObj ] = useState({
                                                             requiredDescription: false,
                                                             requiredTitle: false,
                                                         })

    useEffect(() => {
        if (descriptionValue.trim() === '') {
            setValidationObj((v) => {return { ...v, ...{ requiredDescription: false } }})
        } else {
            setValidationObj((v) => {return { ...v, ...{ requiredDescription: true } }})
        }
    }, [ descriptionValue ])
    useEffect(() => {
        if (titleValue.trim() === '') {
            setValidationObj((v) => {return { ...v, ...{ requiredTitle: false } }})
        } else {
            setValidationObj((v) => {return { ...v, ...{ requiredTitle: true } }})
        }
    }, [ titleValue ])

    const onAddHandler = async (e: React.FormEvent) => {
        e.preventDefault()
        setStartValidation(true)
        if (Object.values(validationObj).every(item => item)) {
            setLoader(true)
            const dataAddObject = {
                description: descriptionValue.trim(),
                status: TICKETSTATUS.OPEN,
                name: titleValue.trim()
            }

            dispatch(dTicketsAddItemSagaAC(dataAddObject, filters))
            setOpenPopup(false)
            // }
        } else {return}
    }

    const isDisabled = startValidation ? ( !( validationObj.requiredDescription && validationObj.requiredTitle ) ) : false

    return (

        <form className="grid md:grid-cols-2">
            <div className="md:col-span-2">
                <div className="mb-2 ">
                    <InputText
                        id="title"
                        name="title"
                        label={ <Trans>Title</Trans> }

                        value={ titleValue }
                        onChange={ titleChangeValueHandler }
                        required={ true }
                        errorMessage={ startValidation ? validationObj.requiredTitle ? undefined :
                            <Trans>Required field</Trans> : undefined }
                        autoFocus={ true }
                        maxLength={ 150 }
                    />

                    { titleValue.length > 150 &&
                        <p className={ `text-xs mt-1 text-red-500` }>
                            { <Trans>150 characters maximum. Now <span>{ titleValue.length }</span></Trans> }
                        </p>
                    }
                </div>
                <div>
                    <InputTextarea
                        labelClassName="text-left flex"
                        id="description" name="description"
                        value={ descriptionValue }
                        onChange={ descriptionChangeValueHandler }
                        label={ <Trans><PencilAltIcon className="h-5 w-5 mr-2"/> Tickets description</Trans> }
                        rows={ 10 }
                        required={ true }
                        errorMessage={ startValidation ? validationObj.requiredDescription ? undefined :
                            <Trans>Required field</Trans> : undefined }
                        maxLength={ 255 }
                    />
                    <p className={ `text-xs mt-1 text-${ descriptionValue.length > 255 ? 'red' : 'grey' }-500` }>{
                        <Trans>255
                            characters maximum. Now <span>{ descriptionValue.length }</span></Trans> }</p>

                </div>
            </div>


            <div className="flex gap-4 mt-5 sm:mt-4 flex-row-reverse">

                <Button type="submit" disabled={ isDisabled } variant={ variant } label={ <Trans>Add</Trans> }
                        onClick={ (e) => onAddHandler(e) }/>
                <Button type="button" secondary={ true } label={ <Trans>Cancel</Trans> }
                        onClick={ () => setOpenPopup(false) }/>

            </div>
            { loader ? <Loader/> : null }
        </form>

    )
}
